import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { Field } from '@sb-tools/typescript/models/field.model';
import { FieldType } from '@sb-tools/typescript/enums/field-type.enum';
import { ClientField } from '../../models/client-field.model';
import { TicketStatusPipe } from '../../pipes/ticket-status.pipe';

@Component({
    selector: 'sb-read-only-field',
    templateUrl: './read-only-field.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [DatePipe, TicketStatusPipe, FormsModule],
})
export class ReadOnlyFieldComponent {
    @Input() formField: Field | ClientField;

    fieldTypes = FieldType;

    get displayValue(): string {
        const value = this.formField.value;
        if (value == null) {
            return '';
        }

        if (Array.isArray(value)) {
            return value.map((item) => this.getItemLabel(item)).join(', ');
        }

        return this.getItemLabel(value);
    }

    get attachments(): { name: string; url: string }[] {
        return Array.isArray(this.formField.value) ? this.formField.value : [];
    }

    get isChecked(): boolean {
        return this.formField.value === true || this.formField.value === 'true';
    }

    get dateValue(): string | number | Date | null {
        const value = this.formField.value;
        if (value == null || value === '') {
            return null;
        }

        return !isNaN(new Date(value).getTime()) ? value : null;
    }

    private getItemLabel(value: unknown): string {
        if (value != null && typeof value === 'object') {
            const item = value as {
                name?: string;
                email?: string;
                value?: string | number;
            };
            return String(item.name ?? item.email ?? item.value ?? JSON.stringify(value));
        }

        return String(value ?? '');
    }
}
